import { Button, FormLabel, Grid, Input, Modal, Switch, TextField } from "@mui/material"
import ContainerModal from "../../../../../components/modalExportar/components/containerModal";
import ServicesEdit from "./services";
import useNav from "../../../../../hooks/useNav";
import { forwardRef } from "react";
import DatePicker from 'react-datepicker'
import { format } from "date-fns";

const InputDate = forwardRef((
  ({ value, onClick }, ref) => {
    return (
      <Input
      type={'datetime'}
      sx={{ width: '100%' }}
      onClick={onClick}
      value={value}
      ref={ref}
      />
    )
  }));

export const EditPage = () => {

  const { goBack } = useNav()

  const onClose = () => goBack();

  const { evento, alterEvento, handleUpdate } = ServicesEdit();

  return (
    <>
      <Modal open onClose={onClose}>
        <ContainerModal>
          <div style={{ borderBottom: '1px solid #ccc', marginBottom: '8px', padding: '8px 0' }}>
            <p style={{}}>Editar</p>
          </div>
          <Grid sx={{ display: 'grid', gap: 1 }}>
            <Grid sx={{ display: 'grid' }}>
              <FormLabel>Descrição</FormLabel>
              <TextField
                value={evento?.descricao}
              />
            </Grid>
            <Grid sx={{ display: 'grid' }}>
              <FormLabel>Início</FormLabel>
              <DatePicker
                selected={evento?.inicioForm}
                dateFormat={'Pp'}
                showTimeSelect
                onChange={(event) => {
                  alterEvento('inicio', format(event, 'yyyy-MM-dd hh:mm'))
                  alterEvento('inicioForm', event)
                }}
                customInput={<InputDate />}
              />
            </Grid>
            <Grid sx={{ display: 'grid' }}>
              <FormLabel>Fim</FormLabel>
              <DatePicker
                selected={evento?.fimForm}
                showTimeSelect
                dateFormat={'Pp'}
                onChange={(event) => {
                  alterEvento('fim', format(event, 'yyyy-MM-dd hh:mm'))
                  alterEvento('fimForm', event)
                }}
                customInput={<InputDate />}
              />
            </Grid>
            <Grid sx={{ display: 'grid' }}>
              <FormLabel>CEP</FormLabel>
              <TextField
                value={evento?.descricao}
              />
            </Grid>
          </Grid>
          <Grid>
            <FormLabel>Ativo</FormLabel>
            <Switch checked={evento?.ativo} onClick={() => alterEvento('ativo', !evento?.ativo)}/>
          </Grid>
          <Grid>
            <FormLabel>Permite Inscrição?</FormLabel>
            <Switch checked={evento?.inscricao} onClick={() => alterEvento('inscricao', !evento?.inscricao)}/>
          </Grid>
          <div style={{ display: 'flex', justifyContent: 'space-between', margin: '8px 0', alignItems: 'center' }}>
            <Button color="error" onClick={onClose}>Cancelar</Button>
            <Button
              variant="contained"
              sx={{ boxShadow: 'none' }}
              onClick={handleUpdate}
            >
              Confirmar
            </Button>
          </div>
        </ContainerModal>
      </Modal>
    </>
  )
}
